define.alias("shared/components/shared/social/refresh-profile/pinterest", "preview-grid/components/shared/social/refresh-profile/pinterest");